import {
    ITooltipProperties,
    TOOLTIP_CLASSNAME_TRIGGER_ELEMENT,
    createTooltip,
} from '@vfde-brix/ws10/tooltip';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { trackTooltipHover } from '@vfde-sails/tracking';
import { getCMSConfig } from '../util/cms';
import { JarvisProduct } from '@vfde-sails/availability';
import { replaceTariffTooltipPlaceholders } from '../util/formatter';

const TOOLTIP_CLASSNAME = 'subline-tooltip';

const addTooltipTrackingEvent = (tooltipId: string) => {
    const tooltipEl = document.getElementById(tooltipId);
    const [tooltipIcon] = tooltipEl?.parentElement?.getElementsByClassName(TOOLTIP_CLASSNAME_TRIGGER_ELEMENT) || [];

    tooltipIcon?.removeEventListener('mouseover', trackTooltipHover);
    tooltipIcon?.addEventListener('mouseover', trackTooltipHover, { once: true });
};

/**
 * Creates a WS10 Tooltip component.
 */
export const mountTooltip = (id: string, props?: ITooltipProperties) => {
    const tooltip = createComponentById(createTooltip, id, props ?? NO_PATTERN_BUSINESS_LOGIC);

    tooltip && addTooltipTrackingEvent(id);

    return tooltip;
};

/**
 * Creates an Tooltip inner HTML with the given ID
 */
export const createTooltipInnerHtml = (id: string): string => {
    const iconClasses = 'ws10-system-icon ws10-system-icon--size-150 ws10-system-icon--color-inherit';
    const iconEl = `<svg class="${iconClasses}"><use xlink:href="/simplicity/icons/info-circle.svg#icon"></use></svg>`;
    const ownerEl = `<span aria-describedby="${id}" class="${TOOLTIP_CLASSNAME}">${iconEl}</span>`;

    return `${ownerEl}<span id="${id}"></span>`;
};

/**
 * Mounts the tooltip in the Offer Summary Card's subline
 */
export const mountSummaryCardTooltip = (id: string, tariff: JarvisProduct) => {
    const { tooltip } = getCMSConfig().offerSummaryCard.tariffSubline;

    if (!tooltip) {
        return null;
    }

    return mountTooltip(id, {
        stdTooltipId: id,
        stdHeadline: tooltip.headline,
        txtContent: replaceTariffTooltipPlaceholders(tooltip.text, tariff),
        business: NO_PATTERN_BUSINESS_LOGIC,
    });
};
